import {
  createApp
} from 'vue'
import App from './App.vue'
import router from '@/router/index'
import { store } from '@/store/index'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { getUserAuthPages } from '@/api/auth'
import message from '@/utils/message'
import format from '@/utils/format'
import config from '@/utils/config'
import { filterAsyncRouter } from '@/utils/asyncRoute'
import DataVVue3 from '@kjgl77/datav-vue3'
import { useRouteStore } from '@/store/route'
import moment from "moment"
//import 方式
import 'moment/locale/zh-cn'
moment.locale('zh-cn');
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' // 进度条样式
import '@/css/layout.scss'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'; // 引入样式文件

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//环境变量
const env_ = import.meta.env
export const env = {
  webUrl: env_.VITE_APP_WEB_URL,
  apiUrl: env_.VITE_APP_API_URL,
}
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const msg = new message()
app.config.globalProperties.env = env
app.config.globalProperties.webUrl = env.webUrl
app.config.globalProperties.apiUrl = env.apiUrl
app.config.globalProperties.$config = config
app.config.globalProperties.format = format
app.config.globalProperties.moment = moment
app.config.globalProperties.successNotify = msg.successNotify
app.config.globalProperties.warningNotify = msg.warningNotify
app.config.globalProperties.infoNotify = msg.infoNotify
app.config.globalProperties.errorNotify = msg.errorNotify
app.config.globalProperties.successMsg = msg.successMsg
app.config.globalProperties.errorMsg = msg.errorMsg
app.config.globalProperties.warningMsg = msg.warningMsg
app.config.globalProperties.confirm = msg.confirm

const whiteList = ['/login', '/authredirect','/ruzhu'] // 白名单，可直接访问;
let hasRoles = true
NProgress.configure({
  showSpinner: false,
}) // 进度配置;
router.beforeEach((to, from, next) => {
  NProgress.start() // 开始显示进度条
  var token = localStorage.getItem('X-Token')
  if (to.meta.title) {
    document.title = to.meta.title
  } else if (to.query.title) {
    document.title = to.query.title
  }
  /** ********************/
  if (token) {
    if (to.path === '/login') {
      next({
        path: '/',
      })
      NProgress.done() // 结束进度条
    } else {
      const useRoute = useRouteStore()
      if (useRoute.addRouters.length <= 0) {
        getUserAuthPages().then((r) => {
          let base_router = JSON.stringify(r);
          const filterAsyncRouters = filterAsyncRouter(JSON.parse(base_router))
          useRoute.setRouters(filterAsyncRouters)
          localStorage.setItem('X-Routes', JSON.stringify(base_router))
          if (hasRoles) {
            filterAsyncRouters.forEach((route) => {
              router.addRoute(route)
            })
            hasRoles = false
            next({ ...to, replace: true }) // 这里相当于push到一个页面 不在进入路由拦截
          } else {
            next()
          }
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

// app.directive('dragDialog', elDragDialog)
app.use(store)
app.use(router)
app.use(VideoPlayer)
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
  zIndex: 3000
})
app.use(DataVVue3)
app.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
})
// app.use(ElementPlus, { size: 'small', zIndex: 3000 })
// app.use(ElementPlus)

app.mount('#app')
